/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/extensions"/>

export const nameOf = <T>(name: keyof T) => name;

export const propertiesOf = <TObj>() => Object.getOwnPropertyNames(<TObj>{});